var _circle, _circle2, _circle3, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgApprovalInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 151,
    viewBox: "0 0 153 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 76.5,
    cy: 75.5,
    r: 70,
    stroke: "#C9FAC5",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 76.5,
    cy: 75.5,
    r: 75,
    stroke: "#C9FAC5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 75.5,
    r: 63.5,
    stroke: "#C9FAC5",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 75C16 41.8629 42.8629 15 76 15C109.137 15 136 41.8629 136 75C136 108.137 109.137 135 76 135C42.8629 135 16 108.137 16 75Z",
    fill: "#20B970"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18962_433316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.75 65.25H96.5V69.5859L82.7891 83.2969L81.1484 94.3125L80.7969 99L96.2656 96.7734L96.5 96.5391V106.5H51.5V70.835C53.3531 71.5852 55.3779 72 57.5 72C66.3366 72 73.5 64.8366 73.5 56C73.5 52.4427 72.3386 49.1568 70.375 46.5H77.75V65.25ZM59.6719 95.7188L58.5938 96.75L60.75 98.9062L61.7812 97.8281L76.3594 83.25L74.25 81.1406L59.6719 95.7188ZM70.875 93.375V98.625H76.125V93.375H70.875ZM111.5 76.3828L94.8594 92.9062L85.25 94.3125L86.5391 84.5859L103.18 68.0625L111.5 76.3828ZM58.875 81.375V86.625H64.125V81.375H58.875ZM119 68.8828L114.078 73.8047L105.758 65.4844L110.68 60.5625L119 68.8828ZM57.5254 43C62.1465 43 66.4121 45.4883 68.748 49.5C71.084 53.5625 71.084 58.4883 68.748 62.5C66.4121 66.5625 62.1465 69 57.5254 69C52.8535 69 48.5879 66.5625 46.252 62.5C43.916 58.4883 43.916 53.5625 46.252 49.5C48.5879 45.4883 52.8535 43 57.5254 43ZM96.5 61.5H81.5V46.5L96.5 61.5ZM55.9004 57.5234L52.7012 54.3242L50.9746 56.0508L55.9004 60.9766L64.0762 52.8008L62.3496 51.0742L55.9004 57.5234Z",
    fill: "url(#paint0_linear_18962_433316)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18962_433316",
    x: 34.5,
    y: 35,
    width: 94.5,
    height: 83.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164775 0 0 0 0 0.473295 0 0 0 0 0.211053 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18962_433316"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18962_433316",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18962_433316",
    x1: 81.25,
    y1: 42,
    x2: 81.25,
    y2: 106.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFFE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgApprovalInvoice);
export default __webpack_public_path__ + "static/media/img_approval_invoice.c159d5fc4340e77c9ab880bc5f9182ed.svg";
export { ForwardRef as ReactComponent };